<div [@routerTransition]>
    <sub-header [title]="('StockTransfer' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group m-form__group">
                            <label for="PaymentTermName">{{ l('FromLocation') }}</label>
                           <input type="text"  class="form-control" disabled="disabled" [(ngModel)]="this.fromLocation"/>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group m-form__group">
                            <label for="ToLocation">{{ l('ToLocation') }}</label>
                            <select name="stockTransfer.toLocation"  [(ngModel)]="stockTransfer.toLocationId"
                                    class="form-select">
                                <option value="">{{ l('SelectToLocation') }}</option>

                                <option *ngFor="let item of allLocations" value="{{ item.id }}">
                                    {{ item.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="stockTransfer_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #stockTransfer_date="ngModel" [(ngModel)]="stockTransfer.transferDate"
                                                 id="stockTransfer_date" name="stockTransfer_transferDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="stockTransfer_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="stockTransfer_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   id="stockTransfer_Remarks" class="form-control"
                                   [(ngModel)]="stockTransfer.remarks" name="Remarks" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>
                                    <th width="8%">{{ l('Cost') }}</th>
                                    <th width="8%">{{ l('TotalCost') }}</th>
                                    <th width="8%">{{ l('Price') }}</th>
                                    <th width="8%">{{ l('TotalPrice') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of stockTransferDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td> <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.productCode" (keydown.enter)="searchProduct(data.productCode,data,i)" (blur)="searchProduct(data.productCode,data,i)"  /> </td>
                                    <td>
                                        <app-search-product (productEvent)="getProduct($event,data,i)" [productSelectedItem]="data.productSelectedItem"> </app-search-product>
                                    </td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <a *ngIf="!data.changeUnitFlag" (click)="changeUnit(data)"><span><b> {{data.unitName}} </b> </span> </a>
                                        <select name="data.unitId" *ngIf="data.changeUnitFlag"
                                                [(ngModel)]="data.unitId"
                                                class="form-select"
                                                required>
                                            
                                            <option *ngFor="let item of data.applicableUnits" value="{{ item.unitId }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><input type="text" #costInput (keydown.enter)="focusNext('focQty', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.cost" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="text-end"><b>{{data.totalCost }}</b></td>
                                    <td><input type="text" #itemDiscountPercInput (keydown.enter)="focusNext('itemDiscount', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.price" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="text-end"><b>{{data.totalPrice }}</b></td>
                                    <td width="5%" class="text-center">
                                        <button  #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)" >
                                           +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    <div class="row" style="margin-right:8px;">
                                        <div class="col-md-8">&nbsp;&nbsp;</div>
                                        
                                    </div>
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PSubTotal">{{ l('TotalQty') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="stockTransfer_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferQty" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PGrandTotal">{{ l('TotalCost') }}</label>
                                                <input type="number"
                                                       id="stockTransfer_PGrandTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferTotal" name="PGrandTotal" readonly="readonly" />
                                            </div>
                                        </div> 
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PNetTotal">{{ l('TotalPrice') }}</label>
                                                <input type="number"
                                                       id="stockTransfer_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferTotalPrice" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(status.Transferred)" *ngIf="stockTransfer.id == null"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }} </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
